import type { ChartConfig, CurveReference, CurveStyling, StyledCurveReference } from '@/interfaces/waveChart'
import { pickNextColorForChart } from './ColorPalette'

/**
 * Builds a StyledCurveReference for a new curve being added to a chart,
 * applying sensible defaults and picking the next color from the chart palette.
 * If overrides are provided, they take precedence over defaults.
 */
export function assignDefaultCurveStyling(
  chart: ChartConfig | undefined,
  reference: CurveReference,
  overrides?: Partial<CurveStyling>,
  fallbackColor = '#2196f3'
): StyledCurveReference {
  const color = overrides?.color ?? (chart ? pickNextColorForChart(chart) : fallbackColor)

  const styling: CurveStyling = {
    color,
    lineStyle: 'solid',
    strokeThickness: 2,
    showDataPoints: false,
    pointSize: 4,
    pointStyle: 'circle',
    interpolation: 'linear',
    ...overrides,
  }

  return {
    reference,
    styling,
  }
}

